<template>
  <div class="missions-id">
    <mission-form-end
      :mission="mission"
      @submit="onMissionFormEndSubmit"
      ref="missionFormEnd"
    />
    <v-card class="d-flex flex-column">
      <!-- <v-card-title class="flex-grow-0" ref="header">
        <span class="h6">
          {{ mission.name }} {{ mission.thirdPartyCode }}
          <span v-if="missionAssetSelected">{{ missionAssetSelected.asset_id }}</span>
        </span>
      </v-card-title> -->
      <v-card-text class="flex-grow-1" ref="container">
        <mission-questions
          v-if="missionAssetSelected"
          :mission="mission"
          :mission-id="mission.id"
          @cancel="onMissionQuestionsCancel"
          @finish="onMissionQuestionsFinish"
        />
        <mission-mapbox
          v-show="!missionAssetSelected"
          :mission="mission"
          :height="mapHeight"
          :pick-asset-ids-for-buttons="pickAssetIdsForButtons"
          :decorate-geojson="decorateMissionAssetsGeojson"
          :filter-geojson="filterMissionAssetsGeojson"
          @select-asset="onMissionMapSelectAsset"
          @user-location="onUserLocationChange"
          ref="missionMap"
        >
          <template #map-footer>
            <div class="d-flex flex-wrap mx-n3">
              <div class="flex-grow-1 px-3">
                <v-btn light x-large block @click="exit">
                  CANCEL
                </v-btn>
              </div>
              <div class="flex-grow-1 px-3">
                <v-btn light x-large block :loading="ending" @click="end">
                  END MISSION
                </v-btn>
              </div>
            </div>
          </template>

          <template #button-footer>
            <div class="col col-3">
              <v-btn x-large block
                outlined
                :color="missionAssetOptions.showInspectedButtons ? 'dark' : 'white'"
                :text="!missionAssetOptions.showInspectedButtons"
                @click="missionAssetOptions.showInspectedButtons = ! missionAssetOptions.showInspectedButtons">
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-btn>
            </div>
            <div class="col col-3">
              <v-btn x-large block
                :color="missionAssetFilters.groups.includes('uninspected') ? getGroupButtonColor('uninspected') : ''"
                @click="onFilterMissionAssetsByGroupIntent('uninspected')">
                <v-icon>mdi-clipboard-outline</v-icon>
              </v-btn>
            </div>
            <div class="col col-3">
              <v-btn x-large block
                :color="missionAssetFilters.groups.includes('passed') ? getGroupButtonColor('passed') : ''"
                @click="onFilterMissionAssetsByGroupIntent('passed')">
                <v-icon>mdi-clipboard-check-outline</v-icon>
              </v-btn>
            </div>
            <div class="col col-3">
              <v-btn x-large block
                :color="missionAssetFilters.groups.includes('failed') ? getGroupButtonColor('failed') : ''"
                @click="onFilterMissionAssetsByGroupIntent('failed')">
                <v-icon>mdi-clipboard-remove-outline</v-icon>
              </v-btn>
            </div>
          </template>
        </mission-mapbox>
      </v-card-text>
    </v-card>

    <mission-asset-dialog
      :show.sync="missionAssetDialogVisible"
      :mission-asset="missionAssetForReview"
      @mission-asset-deleted="onMissionAssetDeleted">
      </mission-asset-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { denormalize } from "@/helpers/JsonApiDenormalizer";
import { MissionService } from "@/services/mission.service";
import { MissionAssetService } from "@/services/missionAsset.service";
import MissionFormEnd from "@/components/Mission/MissionFormEnd";
// import MissionMap from "@/components/Mission/MissionMap";
import MissionQuestions from "@/components/Mission/MissionQuestions";
import MissionMapbox from "@/components/Mission/MissionMapbox";
import MissionAssetDialog from "@/components/MissionAsset/MissionAssetDialog";

const getDefaultFilters = () => {
  return { groups: ['uninspected', 'passed', 'failed'] };
};

export default {
  components: {
    MissionFormEnd,
    // MissionMap,
    MissionMapbox,
    MissionQuestions,
    MissionAssetDialog
  },
  data: () => ({
    mapHeight: 0,
    mission: {},
    missionAssetSelected: null,
    missionAssetForReview: null,
    missionAssetDialogVisible: false,
    missionAssetFilters: getDefaultFilters(),
    missionAssetOptions: { showInspectedButtons: false },
    trackPosition: {}, // location at the time of selecting an asset
    lastKnownUserLocation: null,
    ending: false
  }),
  computed: {
    ...mapGetters("config", ["getTerminology"]),
    assetsVisited() {
      let assets = [];
      if (this.mission && this.mission.missionAssets) {
        assets = this.mission.missionAssets.map(asset => asset.coreId);
      }
      return assets;
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const mission = await MissionService.find(to.params.id, {
        include: "missionAssets,inspectedForFirm"
      }).then(response => denormalize(response.data));
      next(vm => (vm.mission = mission));
    } catch (err) {}
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  async beforeRouteUpdate(to, from, next) {
    this.$store.commit("startLoading");

    this.mission = {};

    try {
      this.mission = await MissionService.find(to.params.id, {
        include: "missionAssets,inspectedForFirm"
      }).then(response => denormalize(response.data));
      next();
    } catch (err) {}

    this.$store.commit("endLoading");
  },
  mounted() {
    this.mapHeight = this.$refs.container.clientHeight - 32;
      // - (this.$refs.header.clientHeight + 32); // card text padding
  },
  watch: {
    mission(mission) {
      this.$store.commit("missions/SET_SELECTED", mission);
    },
    missionAssetForReview(val) {
      this.missionAssetDialogVisible = val ? true : false;
    },
  },
  methods: {
    async reloadMissionData() {
      this.$store.commit('startLoading');
      try {
        const mission = await MissionService.find(this.$route.params.id, {
          include: "missionAssets,inspectedForFirm"
        }).then(response => denormalize(response.data));
        this.mission = mission;
        return mission;
      }
      catch (err) {
        window.console && console.log(err);
      }
      finally {
        this.$store.commit('endLoading');
      }
    },
    assetHasBeenVisited(asset) {
      return this.assetsVisited.includes(asset.asset_id);
    },
    async createMissionAsset({ comment_text, questions, files }) {
      try {
        const data = {
          comment_text,
          mission_id: this.mission.id,
          core_id: this.missionAssetSelected.asset_id,
          third_party_code: this.missionAssetSelected.asset_third_party_code || undefined,
          q_and_a: questions,
          lat: this.trackPosition.lat,
          lng: this.trackPosition.lng,
          is_new_asset: this.missionAssetSelected.isNew ? 1 : undefined,
          file_ids: files
        };

        this.missionAssetSelected = null;

        const missionAsset = await MissionAssetService.create(
          data
        ).then(response => denormalize(response.data));

        if (!this.mission.missionAssets) {
          this.$set(this.mission, "missionAssets", []);
        }

        this.mission.missionAssets.push(missionAsset);

        this.$store.commit("snacktime", {
          text: "Mission asset has been created."
        });
      } catch (err) {}
    },
    exit() {
      this.$router.replace({ name: "missions" });
    },
    end() {
      this.$refs.missionFormEnd.open();
    },
    onReviewInspectionIntent(asset) {
      let missionAsset = this.mission.missionAssets.find(ma => {
        // If the asset was emitted by mapbox component, its ID may be
        // on a different property so we need to look out for that.
        const needle_id = asset.coreId || asset.asset_id;
        return ma.coreId == needle_id;
      });
      if (missionAsset) {
        this.missionAssetDialogVisible = true;
        this.missionAssetForReview = missionAsset;
      }
    },
    onMissionMapSelectAsset(asset) {
      if (this.assetHasBeenVisited(asset)) {
        this.onReviewInspectionIntent(asset);
      }
      else {
        this.missionAssetSelected = asset;
        this.trackPosition = this.lastKnownUserLocation
          ? {
              lat: this.lastKnownUserLocation.lat,
              lng: this.lastKnownUserLocation.lng
            }
          : {};
      }
    },
    onMissionQuestionsCancel() {
      this.missionAssetSelected = null;
    },
    onMissionQuestionsFinish(data) {
      this.createMissionAsset(data);
    },
    onMissionFormEndSubmit() {
      this.exit();
    },
    onUserLocationChange(position) {
      this.lastKnownUserLocation = position;
    },
    onMissionAssetDeleted(payload) {
      const vm = this;
      const { redo, missionAsset } = payload;
      this.reloadMissionData().then(mission => {
        if (redo) {
          // In case the user has a set of filters that would exclude the
          // relevant asset from showing, we should reset the filters.
          if ( ! this.missionAssetFilters.groups.includes['uninspected']) {
            this.missionAssetFilters.groups.push('uninspected');
            // this.missionAssetFilters = getDefaultFilters();
          }
          this.$nextTick(() => {
            vm.$refs.missionMap.selectAssetById(missionAsset.coreId);
          });
        }
      });
    },
    onFilterMissionAssetsByGroupIntent(toggle) {
      let group_index = this.missionAssetFilters.groups.indexOf(toggle);
      if (group_index < 0) {
        // Add
        this.missionAssetFilters.groups.push(toggle);
      }
      else {
        // Remove
        this.missionAssetFilters.groups.splice(group_index, 1);
      }
    },
    filterMissionAssetsGeojson(geojson) {
      // This method intended to be passed into child MissionMapbox component
      // so it can be executed against the map geojson payload before draw.
      if (this.missionAssetFilters.groups.length > 0) {
        let show_passed = this.missionAssetFilters.groups.includes('passed');
        let show_failed = this.missionAssetFilters.groups.includes('failed');
        let show_uninspected = this.missionAssetFilters.groups.includes('uninspected');
        let asset_ids_passed = [];
        let asset_ids_failed = [];
        let asset_ids_inspected = [];
        if (this.mission && this.mission.missionAssets) {
          this.mission.missionAssets.forEach(ma => {
            asset_ids_inspected.push(ma.coreId);
            const passFail = ma.passFail.toLowerCase();
            const is_pass = (passFail === 'pass');
            const is_fail = (passFail === 'fail');
            if (is_pass) asset_ids_passed.push(ma.coreId);
            if (is_fail) asset_ids_failed.push(ma.coreId);
          });
        }
        let features = geojson.features.filter(f => {
          let asset_id = f.properties.asset_id;
          if (asset_id) {
            if ( ! show_passed && asset_ids_passed.includes(asset_id)) return false;
            if ( ! show_failed && asset_ids_failed.includes(asset_id)) return false;
            if ( ! show_uninspected && ! asset_ids_inspected.includes(asset_id)) return false;
          }
          return true;
        });
        geojson.features = features;
      }
      else geojson.features = [];
      return geojson;
    },
    decorateMissionAssetsGeojson(geojson) {
      // This method intended to be passed into child MissionMapbox component
      // so it can be executed against the map geojson payload before draw.
      // (we use it to set colors for markers using relevant information)
      const vm = this;
      const missionAssets = this.mission && this.mission.missionAssets
        ? this.mission.missionAssets
        : [];
      let features = geojson.features || [];
      // NOTE: We're currently relying on having distance/proximity
      // already available (added to geojson in MissionMapBox)
      features = features.sort((a, b) => {
        return a.properties.distance - b.properties.distance; // shortcut since we're sorting numbers
      });
      // IMPORTANT: These arrays get IDs added to them in order of proximity
      // so that we can use the order to determine marker colour profile.
      // (we rely on features already being sorted by proximity above)
      let passed_asset_ids = [];
      let failed_asset_ids = [];
      let closest_asset_ids = [];
      let inspected_asset_ids = [];
      let uninspected_asset_ids = [];
      features.forEach(feature => {
        let asset_id = feature.properties.asset_id;
        if (asset_id) {
          if (closest_asset_ids.length < 3) {
            closest_asset_ids.push(asset_id);
          }
          const ma = missionAssets.find(ma => {
            return (ma.coreId && ma.coreId == asset_id);
          });
          if (ma) {
            inspected_asset_ids.push(ma.coreId);
            const passFail = ma.passFail.toLowerCase();
            if (passFail == 'fail') {
              failed_asset_ids.push(ma.coreId);
            }
            else if (passFail == 'pass') {
              passed_asset_ids.push(ma.coreId);
            }
          }
          else {
            uninspected_asset_ids.push(asset_id);
          }
        }
      });
      features.forEach((feature, i) => {
        // Colours defined in conversation between RN and CD
        // https://sitevitals.slack.com/archives/DAJFVEULQ/p1628570725091200
        // https://sitevitals.slack.com/archives/DAJFVEULQ/p1632877937060000
        let pass_fail = null;
        let marker_profile = 'default';
        const asset_id = feature.properties.asset_id;
        if (passed_asset_ids.includes(asset_id)) {
          pass_fail = 'pass';
          marker_profile = 'success-x';
          let close_index = passed_asset_ids.indexOf(asset_id);
          if (close_index === 0) marker_profile = 'success-0';
          if (close_index === 1) marker_profile = 'success-1';
          if (close_index === 2) marker_profile = 'success-2';
        }
        else if (failed_asset_ids.includes(asset_id)) {
          pass_fail = 'fail';
          marker_profile = 'danger-x';
          let close_index = failed_asset_ids.indexOf(asset_id);
          if (close_index === 0) marker_profile = 'danger-0';
          if (close_index === 1) marker_profile = 'danger-1';
          if (close_index === 2) marker_profile = 'danger-2';
        }
        else {
          // Proximity determines marker colour
          marker_profile = 'default'; // used to use nearby-x but only colouring closest 3 now
          let close_index = uninspected_asset_ids.indexOf(asset_id);
          if (close_index === 0) marker_profile = 'nearby-0';
          if (close_index === 1) marker_profile = 'nearby-1';
          if (close_index === 2) marker_profile = 'nearby-2';
        }
        features[i].properties.pass_fail = pass_fail;
        features[i].properties.marker_profile = marker_profile;
      });
      geojson.features = features;
      return geojson;
    },
    pickAssetIdsForButtons(geojson, limit) {
      // This method intended to be passed into child MissionMapbox component
      // so it can be executed against the already filtered+sorted geojson.
      // (gets used to pick which assets have buttons in MissionMapbox)
      let asset_ids = [];
      limit = limit !== undefined ? limit : 10;
      if (geojson !== null) {
        let features = geojson.features || [];
        features.forEach(f => {
          if (asset_ids.length < limit) {
            let asset_id = f.properties.asset_id;
            let has_been_inspected = f.properties.pass_fail ? true : false;
            if ( ! this.missionAssetOptions.showInspectedButtons) {
              if ( ! has_been_inspected) {
                asset_ids.push(asset_id);
              }
            }
            else {
              asset_ids.push(asset_id);
            }
          }
        });
      }
      return asset_ids;
    },
    getGroupButtonColor(group) {
      let color = 'dimgrey';
      let fallback = 'default';
      const map = {
        uninspected: 'nearby-0',
        passed: 'success-0',
        failed: 'danger-0',
      };
      if (this.$refs && this.$refs.missionMap) {
        const profile = map[group] || fallback;
        color = this.$refs.missionMap.colors[profile] || color;
      }
      return color;
    }
  }
};
</script>

<style lang="scss">
.missions-id {
  height: 100%;

  .v-card {
    height: 100%;
  }
}
</style>
